<template>
  <div class="match-details-stats-container">
    <MatchStats :matchDetailScore="matchDetailScore" />
    <RecentMeeting :matchDetailScore="matchDetailScore" />
    <FormGuide :matchDetailScore="matchDetailScore" />
    
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MatchStats from "@/components/matchListings/analysis/MatchStats.vue";
import RecentMeeting from "@/components/matchListings/analysis/RecentMeeting.vue";
import FormGuide from "@/components/matchListings/analysis/FormGuide.vue";

export default {
  props: ["matchDetailScore"],
  components: {
    MatchStats,
    RecentMeeting,
    FormGuide
  },
  computed: {
    ...mapGetters(['manualRefreshMatchDetail']),
  },
};
</script>

<style scoped>
  .match-details-stats-container {
    color: var(--color-text-default-default);
  }
.router-link-exact-active {
  background-color: var(--color-hover);
  border: 0.1rem solid var(--color-hover);
  color: black;
  font-family: var(--weight-700);
}
@media(max-width: 768px) {  /* for test */
  .match-details-stats-container {
  /* background-color: var(--white-1000); */
  
}
}

</style>
